export default __webpack_public_path__ + "static/media/female.a0fad3ca.png";